import { render } from "./TipTable.vue?vue&type=template&id=28c76faa"
import script from "./TipTable.vue?vue&type=script&lang=js"
export * from "./TipTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__